module.exports = __webpack_public_path__ + "static/img/254_TO8_2256.4cffe83.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/254_TO8_2256.jpg
// module id = 5xWP
// module chunks = 0